import React from 'react';
import LogoTextBottom from './img/LogoTextBottom.png'; 
import LogoTextBottom2 from './img/LogoTextBottom2.png'; 
// import PetsIcon from '@mui/icons-material/Pets';
import './css/Banner.css';
import { colors } from '@mui/material';

const Banner = ({ sizeLogo, sizeText }) => {
  return (
    <div className='banner-wrapper'>
      <div className="row banner">
          <div className="col-sm-5">
              <img src={LogoTextBottom} alt="养猫人"  className='img1'/>
          </div>
          <div className="col-sm-2 paw-div">
              <span className='paw'>🐾</span>
          </div>
          <div className="col-sm-5">
              <img src={LogoTextBottom2} alt="互助社区" className='img2' />
          </div>
      </div>
      <a href="https://beian.miit.gov.cn/" style={{color: '#bbb', position: 'fixed', bottom: '7px', right: '10px', fontSize: 'small', textDecoration: 'none'}} target="_blank">蜀ICP备2024091116号</a>
    </div>
    
  );
};

export default Banner;

//https://www.signaturetopng.com/chinese/generator/Hand_painted_generator.php